module.exports = __webpack_public_path__ + "static/media/slogan3.c332826c.jpg";